import { createAction } from "redux-actions";
import { CREDIT_DESTINY, CREDIT_APPLICATION_QUALIFIER, CREDIT_INFORMATION } from "../constants";
import { feathersCreateData } from "../services";

export const getCreditDestiny = createAction(CREDIT_DESTINY, (data) => feathersCreateData('core-server', {
    service: 'DIGITAL CREDIT',
    func: 'CREDIT DESTINY'
})())

export const getCreditApplicationQualifier = createAction(CREDIT_APPLICATION_QUALIFIER, (data) => feathersCreateData('core-server', {
  service: 'DIGITAL CREDIT',
  func: 'CREDIT APPLICATION QUALIFIER',
  data
})())

export const getCreditInformation = createAction(CREDIT_INFORMATION, (data) => feathersCreateData('core-server', {
  service: 'DIGITAL CREDIT',
  func: 'CREDIT INFORMATION',
  data
})())